<template>
    <div>
        <div class="create-asset__top-line create-asset__heading">
            <h2 class="heading heading--lg">
                Screenshots and videos

                <div class="badge badge--red">JPEG</div>
                <div class="badge badge--green">PNG</div>
            </h2>
            <!--TODO: we don't need it now, but probably you should add some class-->
            <div
                v-show="fileItems.length < maxItemsCount"
                class=""
            >
                <file-upload
                    button-label="add image"
                    :max-files="maxItemsCount - fileItems.length"
                    :max-file-size="4"
                    file-type="images"
                    element-name="screenshots-files"
                    element-size="xs"
                    class="create-asset__file-wrapper--multi"
                    @upload-complete="onUploadComplete"
                    @upload-progress="onUploadProgress"
                    @upload-started="onUploadStarted"
                ></file-upload>
                <label
                    class="create-asset__file-label"
                    @click="showAddVideoDialog"
                >
                    <span class="button button--xs button--yellow"
                        >add video</span
                    >
                </label>
            </div>
        </div>

        <div
            :class="
                fileItems.length > 0
                    ? 'create-asset__files'
                    : null
            "
        >
            <ul class="create-asset__files-list">
                <li
                    v-for="(screenshot, index) in fileItems"
                    :key="`screenshot_${index}`"
                >
                    <FileItem
                        :key="screenshot.id || screenshot.file_id"
                        :file-item="screenshot"
                        :name="parseFile(screenshot.data).name"
                        :type="parseFile(screenshot.data).type"
                        size="md"
                        @removed="removeFile(screenshot, index)"
                    />
                </li>

                <li
                    v-for="(screenshot, index) in uploadedScreenshots"
                    :key="`uploaded_screenshot_${index}`"
                >
                    <FileItemLoading
                        :key="screenshot.identifier"
                        :file="screenshot"
                        size="md"
                        @canceled="onCancelUpload"
                    />
                </li>

                <li v-if="errorMessages.length > 0">
                    <div class="file__error">{{ errorMessages.join(',') }}</div>
                </li>
            </ul>
        </div>

        <AddYoutubeVideo ref="addVideoDialog" />
    </div>
</template>
<script>
import { addInfoNotification } from '../../lib/notifications';
import AddYoutubeVideo from '../common/modal/AddYoutubeVideoDialog.vue';
import FileItem from './FileItem.vue';
import FileItemLoading from './FileItemLoading.vue';
import FileUpload from './FileUpload.vue';

import AssetResource from '@/services/assets';

export default {
    components: {
        FileUpload,
        FileItem,
        FileItemLoading,
        AddYoutubeVideo,
    },
    props: ['asset', 'listeners'],
    mounted() {
           let items = [];
            this.asset.videos &&
                this.asset.videos.length > 0 &&
                this.asset.videos.forEach((item, idx) => {
                    item.status = 'uploaded';
                    item.data.name =
                        'https://img.youtube.com/vi/' + item.id + '/mqdefault.jpg';
                    items.push(item);
                });


            this.asset.screenshots &&
                this.asset.screenshots.length > 0 &&
                this.asset.screenshots.forEach((item, idx) => {
                    items.push({...item, status: 'uploaded'});
                });
            this.fileItems = items;
            this.propagateChanges();
    },
    data() {
        return {
            maxItemsCount: 5,
            uploadedScreenshots: [],
            errorMessages: [],
            undoDeleteNotification: {},
            fileItems: [],
            fileItemsToDelete: [],

        };
    },
      watch: {

    // whenever question changes, this function will run
        //  asset(newAsset, oldAsset) {
        //         let items = [];
        //             newAsset.videos &&
        //                 newAsset.videos.length > 0 &&
        //                 newAsset.videos.forEach((item, idx) => {
        //                     item.originalIndex = idx;
        //                     item.data.name =
        //                         'https://img.youtube.com/vi/' + item.id + '/0.jpg';
        //                     items.push(item);
        //                 });

        //             newAsset.screenshots &&
        //                 newAsset.screenshots.length > 0 &&
        //                 newAsset.screenshots.forEach((item, idx) => {
        //                     item.originalIndex = idx;
        //                     items.push(item);
        //                 });
        //             this.fileItems = items;
        //             }
    },
    computed: {
        // getItems() {
        //     let items = [];
        //     this.asset.videos &&
        //         this.asset.videos.length > 0 &&
        //         this.asset.videos.forEach((item, idx) => {
        //             item.originalIndex = idx;
        //             item.data.name =
        //                 'https://img.youtube.com/vi/' + item.id + '/0.jpg';
        //             items.push(item);
        //         });

        //     this.asset.screenshots &&
        //         this.asset.screenshots.length > 0 &&
        //         this.asset.screenshots.forEach((item, idx) => {
        //             item.originalIndex = idx;
        //             items.push(item);
        //         });
        //         console.log(items)
        //     return items;
        // },
    },
    methods: {
        parseFile(file) {
            if (typeof file === 'object' && file !== null) {
                return file;
            } else {
                return JSON.parse(file);
            }
        },
        onUndoDelete(idx) {
            // deep copy object to a tmp var and then remove it, to make UI feel more reactive
            const deletedFile = this.undoDeleteNotification[idx];

            delete this.undoDeleteNotification[idx];
            this.fileItemsToDelete = this.fileItemsToDelete.filter(
                (item) => item.id !== deletedFile.id
            );
            // if (deletedFile.deletedFile.data.type === 'image') {
            //     this.asset.screenshots.splice(
            //         deletedFile.deleteIndex,
            //         0,
            //         deletedFile.deletedFile
            //     );
            // } else {
            //     this.asset.videos.splice(
            //         deletedFile.deleteIndex,
            //         0,
            //         deletedFile.deletedFile
            //     );
            // }
                this.fileItems.splice(
                    deletedFile.deleteIndex,
                    0,
                    deletedFile.deletedFile
                );
                this.$nextTick(() => console.log({fileItems: this.fileItems, fileItemsToDelete: this.fileItemsToDelete}))




            this.propagateChanges();
        },
        async showAddVideoDialog() {
            let data = await this.$refs.addVideoDialog.init();
            if (!data) {
                return;
            }


            this.fileItems.push({
                id: data.id,
                status:"uploaded",
                data: {
                    type: 'video',
                    name: data.link,
                    id: data.id,
                    params: data.params ? { start: data.params.start } : null,
                },
            });

            this.propagateChanges();
        },
        onNotificationClosed(idx) {
            delete this.undoDeleteNotification[idx];
        },
        onCancelUpload(screenshot) {
            screenshot.cancel('User cancelled the upload');
        },
        onUploadStarted(files) {
            this.undoDeleteNotification = {};
            this.errorMessages = [];
            this.uploadedScreenshots = files;
        },
        onUploadProgress(files) {
            this.uploadedScreenshots = files;
        },

        onUploadComplete(files) {
            let validScreenshots = this.parseResults(files);
            for (let i = 0; i < validScreenshots.length; i++) {
                const img =validScreenshots[i];
                this.fileItems.push(img);
            }

            this.propagateChanges();
        },
        parseResults(files) {
            let results = [];
            for (let i = 0; i < files.length; i++) {
                    let file = {
                        name: files[i].fileName,
                        // url: files[i].url,
                        // file_id: files[i].id,
                        // originalIndex: file.originalIndex,
                        status: 'init',
                        data: {
                            formData: files[i].formData,
                            type: 'image',
                            name: files[i].fileName,
                            // file_id: files[i].id,
                        },
                    };
                    if (files[i].thumbnails) {
                        file.data.thumbnails = files[i].thumbnails;
                    }
                    if (files[i].thumbnail_ids) {
                        file.data.thumbnail_ids = files[i].thumbnail_ids;
                    }

                    results.push(file);
            }
            return results;
        },
        async removeFile(screenshot, screenshotIndex) {
            let item = this.fileItems[screenshotIndex];
            let type = screenshot.data.type === 'video' ? 'Video' : 'Screenshot';

            // We have to use unique id, cause we might have same indexes
            const uuid = Math.round(Math.random() * 10000);
            this.undoDeleteNotification[uuid] = {
                deletedFile: screenshot,
            };


            const message = type + ' was deleted';
            this.setNotification(uuid, message);


            this.fileItems.splice(screenshotIndex, 1);
            if (screenshot?.file_id) {
                this.fileItemsToDelete.push({assetId: this.asset.id, screenshot});
            }
            this.$nextTick(() => console.log({fileItems: this.fileItems, fileItemsToDelete: this.fileItemsToDelete}))

            this.propagateChanges();

        },
        propagateChanges() {
            this.listeners.change({
                media: this.fileItems,
                mediaToDelete: this.fileItemsToDelete,
                valid: this.fileItems.length >= 0,
            });
        },
        setNotification(uuid, message) {
            addInfoNotification(message, {
                timeout: 7000,
                cb: result => {
                    if (result) {
                        this.onUndoDelete(uuid);
                    } else {
                        this.onNotificationClosed(uuid);
                    }
                },
            });
        },
    },
};
</script>
